import { OrderHistoryItem, OrdersHistoryQuery } from '@libs/api-reference';
import { LEGACY_ORDER_STATUSES_LABEL } from '../../constants';
import { isModifiedAndEditedState } from './order';

function transformOrderHistory(data: OrdersHistoryQuery) {
  return {
    ...data,
    items: data.items?.map((item: OrderHistoryItem) => {
      const orderStates = item.legacyOrderState
        ? {
            ...item.legacyOrderState,
            orderState: transformOrderLabel({
              ...item.legacyOrderState,
              executedQuantity: item.executedQuantity,
            }),
          }
        : item.newOrderState;

      return {
        ...item,
        ...orderStates,
      };
    }),
  };
}

function transformOrderLabel(order: {
  orderStateEnglishTitle: string | null;
  executedQuantity: number;
}): string {
  return LEGACY_ORDER_STATUSES_LABEL[
    isModifiedAndEditedState(
      order?.orderStateEnglishTitle,
      order?.executedQuantity
    )
  ];
}

export { transformOrderHistory, transformOrderLabel };
